import { styled, TableCell, TableRow } from "@mui/material";

export const AlternatingBackgroundTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd):not(.overwriteBackgroundColor)": {
    backgroundColor: theme.palette.action.hover,
  },
}));

export const CenteredHeaderTableCell = styled(TableCell)((props) => ({
  border: "1px solid rgba(224, 224, 224, 1)",
  padding: "3px 8px",
  textAlign: "center",
  fontSize: "1em",
  ...props.style,
}));

export const CenteredTableCell = styled(TableCell)(() => ({
  borderLeft: "1px solid rgba(224, 224, 224, 1)",
  borderRight: "1px solid rgba(224, 224, 224, 1)",
  padding: "3px 8px",
  transition: "color 1s linear",
  textAlign: "center",
  fontSize: "1em",
}));
